'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dialog = require('../Dialog/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _create = require('material-ui/svg-icons/content/create');

var _create2 = _interopRequireDefault(_create);

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.state = {
      open: false
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.save = _this.save.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'onChange',
    value: function onChange(event, value) {
      this.setState((0, _util.merge)(this.state, { value: value }));
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen() {
      this.setState({
        open: true,
        value: this.props.value
      });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ open: false });
    }
  }, {
    key: 'save',
    value: function save() {
      this.props.onChange(this.state.value);
      this.handleClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          key = _props.key,
          dialog = _props.dialog,
          onChange = _props.onChange,
          iconStyle = _props.iconStyle,
          iconColor = _props.iconColor,
          visible = _props.visible,
          value = _props.value,
          formatValue = _props.formatValue,
          others = _objectWithoutProperties(_props, ['key', 'dialog', 'onChange', 'iconStyle', 'iconColor', 'visible', 'value', 'formatValue']);

      return _react2.default.createElement(
        'div',
        { style: { visibility: visible ? 'visible' : 'hidden' }, key: key },
        _react2.default.createElement(_TextField2.default, _extends({}, others, {
          value: formatValue(value),
          underlineDisabledStyle: { display: 'none' },
          disabled: true
        })),
        _react2.default.createElement(
          _IconButton2.default,
          {
            iconStyle: iconStyle,
            onTouchTap: this.handleOpen
          },
          _react2.default.createElement(_create2.default, { color: iconColor })
        ),
        _react2.default.createElement(
          _Dialog2.default,
          _extends({
            onRequestClose: this.handleClose,
            onCancel: this.handleClose,
            onSubmit: this.save
          }, dialog, {
            open: this.state.open,
            cancel: true,
            submit: true
          }),
          _react2.default.createElement(_TextField2.default, {
            value: this.state.value,
            onChange: this.onChange,
            multiLine: true,
            fullWidth: true
          })
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  value: _react2.default.PropTypes.bool.isRequired,
  onChange: _react2.default.PropTypes.func.isRequired,
  formatValue: _react2.default.PropTypes.func.isRequired
};
_class.defaultProps = {
  onChange: function onChange(value) {
    return String(value);
  }
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/FormattableTextField/FormattableTextField.js
 ** module id = 494
 ** module chunks = 0
 **/